module.exports = __webpack_public_path__ + "img/11.dd21f4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/11.jpg
// module id = 203
// module chunks = 1